import { FactoryProvider } from '@angular/core';
import { AskAiFrameConfig, Settings } from '@mri-platform/shared/core';

export const AskAiFrameConfigProvider: FactoryProvider = {
  provide: AskAiFrameConfig,
  useFactory: (settings: Settings) => new AskAiFrameConfig(settings.askAgoraFrame),
  deps: [Settings]
};
